import React, { useState } from "react";

function FeedbackModal({ onClose, userEmail }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [liked, setLiked] = useState('');
  const [improve, setImprove] = useState('');
  const [role, setRole] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async () => {
    if (!rating) { setError('Please select a star rating.'); return; }
    if (!role) { setError('Please select your role.'); return; }
    setSending(true); setError('');
    try {
      const resp = await fetch('/api/send-contact', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: role,
          email: userEmail || 'anonymous@feedback.sjvm',
          subject: `Feedback: ${rating} stars from ${role}`,
          message: `Rating: ${rating}/5 stars\nRole: ${role}\n\nWhat they liked:\n${liked || '(not provided)'}\n\nWhat could be improved:\n${improve || '(not provided)'}`,
        }),
      });
      if (resp.ok) setSent(true);
      else setError('Failed to send. Please try again.');
    } catch { setError('Failed to send. Please try again.'); }
    setSending(false);
  };

  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:16,maxWidth:440,width:'100%',overflow:'hidden'}}>
        <div style={{background:'#1a1410',padding:'20px 28px',textAlign:'center'}}>
          <div style={{fontSize:20,fontWeight:700,color:'#e8c97a',fontFamily:'Playfair Display,serif'}}>Share Your Feedback</div>
          <div style={{fontSize:13,color:'#a89a8a',marginTop:4}}>Help us improve South Jersey Vendor Market</div>
        </div>
        <div style={{padding:'24px 28px'}}>
          {sent ? (
            <div style={{textAlign:'center',padding:'20px 0'}}>
              <div style={{fontSize:32,marginBottom:8}}>&#10003;</div>
              <div style={{fontSize:16,fontWeight:700,color:'#1a6b3a',marginBottom:8}}>Thanks for your feedback!</div>
              <div style={{fontSize:14,color:'#7a6a5a',marginBottom:20}}>We read every response and use it to make the platform better.</div>
              <button onClick={onClose} style={{background:'#1a1410',color:'#e8c97a',border:'none',borderRadius:8,padding:'10px 24px',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Close</button>
            </div>
          ) : (
            <>
              {/* Star rating */}
              <div style={{marginBottom:16}}>
                <label style={{fontSize:13,fontWeight:600,color:'#1a1410',display:'block',marginBottom:6}}>Overall Rating <span style={{color:'#c0392b'}}>*</span></label>
                <div style={{display:'flex',gap:4}}>
                  {[1,2,3,4,5].map(n=>(
                    <button key={n} onClick={()=>setRating(n)} onMouseEnter={()=>setHover(n)} onMouseLeave={()=>setHover(0)}
                      style={{background:'none',border:'none',fontSize:32,cursor:'pointer',color:(hover||rating)>=n?'#e8c97a':'#e0d5c5',transition:'color 0.1s',padding:0,lineHeight:1}}>
                      &#9733;
                    </button>
                  ))}
                </div>
              </div>
              {/* Role */}
              <div style={{marginBottom:14}}>
                <label style={{fontSize:13,fontWeight:600,color:'#1a1410',display:'block',marginBottom:6}}>I am a... <span style={{color:'#c0392b'}}>*</span></label>
                <div style={{display:'flex',gap:8}}>
                  {['Vendor','Host','Visitor'].map(r=>(
                    <button key={r} onClick={()=>setRole(r)} style={{
                      flex:1,padding:'8px 0',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',
                      border:role===r?'2px solid #c8a84b':'2px solid #e8ddd0',
                      background:role===r?'#fdf9f0':'#fff',color:'#1a1410',
                    }}>{r}</button>
                  ))}
                </div>
              </div>
              {/* Text fields */}
              <div className="form-group" style={{marginBottom:10}}>
                <label>What did you like?</label>
                <textarea value={liked} onChange={e=>setLiked(e.target.value)} placeholder="What's working well..." style={{minHeight:60,resize:'vertical'}} />
              </div>
              <div className="form-group" style={{marginBottom:14}}>
                <label>What could be improved?</label>
                <textarea value={improve} onChange={e=>setImprove(e.target.value)} placeholder="Anything we should do differently..." style={{minHeight:60,resize:'vertical'}} />
              </div>
              {error && <div style={{color:'#c0392b',fontSize:13,marginBottom:12,background:'#fdecea',border:'1px solid #f5c6c6',borderRadius:8,padding:'8px 12px'}}>{error}</div>}
              <button onClick={handleSend} disabled={sending} style={{width:'100%',background:'#c8a84b',color:'#1a1410',border:'none',borderRadius:8,padding:'12px 0',fontSize:15,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',opacity:sending?0.6:1}}>
                {sending ? 'Sending...' : 'Submit Feedback'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default FeedbackModal;
